import st from './DataTable.module.scss';
import { useEffect, useState } from "react";
import Checkbox from "../Checkbox/Checkbox";
import { useImmer } from "use-immer";
import { sortDirection } from "./../../types/sortDirection";
import { renderContent, showMore } from '../../functions/functions';

type DataRow = { id?: any, name?: any | Array<any>, field?: string, render?: any, renderPrices?: any, renderDeposit?: any, style?: object }
type DRow = { id: any, [value: string]: any }
type DataTableTypes = {
    columns?: Array<DataRow> | null;
    data?: Array<DRow> | null;
    classForTable?: string | null;
    classForPagination?: string | null;
    rowsPerPage?: number;
    numPaginationButtons?: number;
    additionalButtons?: boolean;
    isSelectRows?: boolean;
    rowStyle?: (value: any) => any;
    onSelect?: (value: any) => void;
    onRowClick?: (value: any) => any;
    onRowDoubleClick?: (value: any) => any;
}

function DataTable({
    columns = null,
    data = null,
    classForTable = null,
    classForPagination = null,
    rowsPerPage = 10,
    numPaginationButtons = 5,
    additionalButtons = false,
    isSelectRows = false,
    rowStyle,
    onSelect,
    onRowClick,
    onRowDoubleClick,
}: DataTableTypes) {

    const consoleError = (errorField: string) => {
        console.log("Obj property " + errorField + " not found in obj Data");
        return '';
    }

    const [_data, setCData] = useImmer<Array<DRow> | null>(null);
    const startSelectedRows: Array<any> = [];
    const [startRow, setPage] = useState(0);
    const [selectedRows, setSelected] = useImmer(startSelectedRows);

    useEffect(() => {
        setCData(data);
    }, [data]);

    useEffect(() => {
        setPage(0);
    }, [_data]);

    useEffect(() => {
        window.scrollTo({
            top: 0,
        });
    }, [startRow]);

    useEffect(() => {
        if (onSelect) {
            onSelect(selectedRows);
        }
    }, [selectedRows]);

    let numPages = 0;
    let totalPages = 0;

    if (_data?.length) {
        totalPages = _data.length / rowsPerPage;
        if (totalPages > numPaginationButtons) {
            numPages = numPaginationButtons;
        } else {
            numPages = totalPages;
        }
    }

    const getPaginationButtons = (startRow: number) => {
        if (numPages > 0) {
            let content: any = [];
            content.push(
                <div className={st.btn + ' ' + st.btnActive} key={'page_' + startRow}>{startRow + 1}</div>
            );
            for (let i = 0; content.length <= numPages - 1; i++) {

                if ((startRow - i - 1) >= 0) {
                    content.unshift(<div className={st.btn} onClick={() => setPage((startRow - i - 1))}
                        key={'page' + (startRow - i - 1)}>{(startRow - i)}</div>);
                }

                if ((totalPages + 1) > (startRow + i + 2)) {
                    content.push(<div className={st.btn} onClick={() => setPage((startRow + i + 1))}
                        key={'page_' + (startRow + i + 1)}>{(startRow + i + 2)}</div>);
                }
            }
            if (additionalButtons && startRow > 0) {
                content.unshift(<div className={st.btn} onClick={() => setPage((startRow - 1))}
                    key={'page_as_text' + (startRow - 1)}>prev</div>);
            }
            if (additionalButtons && (totalPages + 1) > (startRow + 2)) {
                content.push(<div className={st.btn} onClick={() => setPage((startRow + 1))}
                    key={'page_as_text' + (startRow + 1)}>next</div>);
            }

            return content;
        } else {
            return [];
        }
    }
    const toggleAll = () => {
        if (selectedRows.length > 0) {
            setSelected([]);
        } else {
            setSelected((draft) => {
                _data?.slice(startRow * rowsPerPage, (startRow * rowsPerPage) + rowsPerPage)?.map((item) => {
                    draft.push(item.id);
                });
            });
        }
    }

    const toggleRow = (rowId: any) => {
        setSelected((draft) => {
            let indexInArray = draft.indexOf(rowId);
            if (indexInArray >= 0) {
                draft.splice(indexInArray, 1);
            } else {
                draft.push(rowId);
            }
        });
    }

    return (
        <div className={st.table} style={{ background: 'white' }}>
            {
                _data && _data.length > 0 && Array.isArray(_data) &&
                <>
                    <div className={(classForTable !== null) ? classForTable : ''}>
                        <div className={st.table}>
                            {(columns !== null) ? (
                                <>
                                    <div className={st.headRow}>
                                        <div className={st.tableRow + ' ' + st.headTableRow + ' ' + (localStorage.getItem('user') !== '202' ? st.tableRowAdmin : '')} >
                                            {isSelectRows ? (
                                                <div key={"CHECKED_ALL_TH"} className={st.checkColumn}>
                                                    <Checkbox name={'checkAll'} onChange={toggleAll}
                                                        isChecked={selectedRows.length > 0} />
                                                </div>
                                            ) : (<></>)}
                                            {columns.map(column =>
                                                <>
                                                    {column.id === 'id0' ? <div className={st.itemId} key={'head id0'}>{column.name}</div> : <></>}
                                                    {column.id === 'img0' ? <div className={st.rowImg} key={'head img0'}>{column.name}</div> : <></>}
                                                    {column.id === 'name0' ? <div className={st.modelName} key={'head name0'}>{column.name}</div> : <></>}
                                                    {column.id === 'third0' ? <div className={st.partnerName} key={'head third0'}>{column.name}</div> : <></>}
                                                    {column.id === "prices0" ?
                                                        <div className={st.pricesRow} key={'head prices0'}>
                                                            {column.name.map((field: DataRow, idx: any) =>
                                                                <div className={st.headTableRow} key={'' + field.name}>{field.name}</div>
                                                            )}
                                                        </div> : <></>}
                                                    {column.id === 'Status' ? <div className={st.status} key={'head Status'}>{column.name}</div> : <></>}
                                                    {column.id === 'featured_boost' ? <div className={st.featured_boost} key={'head featured_boost'}>{column.name}</div> : <></>}
                                                    {column.id === 'site' ? <div className={st.site} key={'head site'}>{column.name}</div> : <></>}
                                                    {column.id === 'control' ? <div className={st.control} key={'head control'}>{column.name}</div> : <></>}
                                                </>
                                            )}
                                        </div>
                                    </div>

                                    {(_data !== null) ?
                                        <div className={st.tableContent}>
                                            {_data && _data?.slice(startRow * rowsPerPage, (startRow * rowsPerPage) + rowsPerPage).map((item, indx) => (
                                                <div key={"TR-" + item.id + indx}
                                                    className={st.tableRow + ' ' + (localStorage.getItem('user') !== '202' ? st.tableRowAdmin : '')}
                                                    onClick={() => onRowClick ? onRowClick(item) : undefined}
                                                    onDoubleClick={() => onRowDoubleClick ? onRowDoubleClick(item) : undefined}>
                                                    {isSelectRows ?
                                                        (<div className={st.check} key={"TD____" + (typeof item.id === "undefined") ? indx : item.id + "_" + item.id}>
                                                            <Checkbox name={'check'} value={item.id}
                                                                onChange={() => toggleRow(item.id)}
                                                                isChecked={selectedRows.indexOf(item.id) >= 0} />
                                                        </div>) : (<></>)}

                                                    {columns.map((column, index) => (
                                                        <>
                                                            {/* LIST AUTO */}
                                                            {renderContent(column, item, "id0", `${st.itemId}`)}
                                                            {renderContent(column, item, "img0", `${st.rowImg}`)}

                                                            {column.id === "name0" ?
                                                                column.field !== undefined ?
                                                                    (<div className={st.modelName} key={"TD_" + item.id + "___TDDD"}
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: ((item && typeof item[column.field] !== "undefined") ?
                                                                                item[column.field] : consoleError(column.field))
                                                                        }}>
                                                                    </div>) : null
                                                                : <></>}

                                                            {column.id === "third0" ?
                                                                column.field !== undefined ?
                                                                    (<div className={st.partnerName} key={"TD_" + item.id + "___TDDD"}
                                                                        dangerouslySetInnerHTML={{
                                                                            __html: ((item && typeof item[column.field] !== "undefined") ?
                                                                                item[column.field] : consoleError(column.field))
                                                                        }}>
                                                                    </div>) : null
                                                                : <></>}

                                                            {column.id === "prices0" ?
                                                                <div className={st.prices_block + ' item_more'}>
                                                                    <div className={st.pricesRow}>
                                                                        {column.name.map((field: DataRow, idx: any) => (
                                                                            <>
                                                                                {field.name !== 'Deposit' ?
                                                                                    <div className={st.priceItem}
                                                                                        key={"TD_" + (typeof item.id === "undefined") ? idx : item.id + "___TDD"}>
                                                                                        <div className={st.priceName}> {field.name}  </div>
                                                                                        <div className={st.priceValue}> {column.renderPrices(item, field)} </div>
                                                                                    </div>
                                                                                    :
                                                                                    <>
                                                                                        <div className={st.priceItem} key={"TD_Deposit" + idx}>
                                                                                            <div className={st.priceName}>{field.name}</div>
                                                                                            <div className={st.priceValue}>{column.renderDeposit(item)}</div>
                                                                                        </div>
                                                                                    </>
                                                                                }
                                                                            </>
                                                                        ))}
                                                                    </div>
                                                                    <button className={st.more_btn} onClick={(e) => showMore(e, st.active)}>&nbsp;</button>
                                                                </div> : <></>}

                                                            {renderContent(column, item, "Status", `${st.status}`)}
                                                            {renderContent(column, item, "featured_boost", `${st.featured_boost}`)}
                                                            {renderContent(column, item, "site", `${st.site}`)}
                                                            {renderContent(column, item, "control", `${st.control}`)}
                                                            {/* LIST AUTO */}
                                                        </>
                                                    ))}
                                                </div>
                                            ))}
                                        </div>
                                        : ''}
                                </>
                            ) : (
                                <>
                                    {(_data !== null) ?
                                        <div className={st.tableContent}>
                                            {_data !== null && _data.map((item, index) => (
                                                <div key={"TR" + item.id + "+" + index}
                                                    onClick={onRowClick ? onRowClick(item) : undefined}
                                                    onDoubleClick={() => onRowDoubleClick ? onRowDoubleClick(item) : undefined}>
                                                    {isSelectRows ? (
                                                        <div key={"TDDDD" + item.id}>
                                                            <Checkbox value={item.id} name={'check'}
                                                                onChange={() => toggleRow(item.id)}
                                                                isChecked={selectedRows.indexOf(item.id) >= 0} />
                                                        </div>
                                                    ) : (<></>)}
                                                    <div key={"TDD" + item.id}>{item.id}</div>
                                                    <div key={"TDDD" + item.id}>{item.value}</div>
                                                </div>
                                            ))}
                                        </div>
                                        : ''}
                                </>
                            )}
                        </div>
                    </div>
                    <div
                        className={(st.pagination ? st.pagination : '') + ' ' + (classForPagination != null ? classForPagination : '')}>
                        <div>
                            {startRow * rowsPerPage}-{(startRow * rowsPerPage + rowsPerPage > (_data as any).length) ? _data?.length : startRow * rowsPerPage + rowsPerPage} of over {_data?.length} results
                        </div>
                        <div className={st.btnList}>
                            {getPaginationButtons(startRow)}
                        </div>
                    </div>
                </>
            }
        </div >);
}

export default DataTable;